import { t } from "ttag";

import { ErrorState } from "@/app/components/legacy-components";
import { usePastMedications } from "@/features/my-meds/hooks";
import { History2Icon, TableSkeleton } from "@/shared/ui";
import { Heading } from "@/shared/ui/common/heading";
import {
  PastMedicationRequestsCards,
  PastMedicationRequestsTable,
} from "./components";

export const PastMedicationRequests = () => {
  const {
    data: pastMedicationRequests,
    isLoading,
    isSuccess,
    isError,
  } = usePastMedications();

  return (
    <section className="flex grow flex-col gap-4 text-neutral-950">
      <Heading level={2} size="x-small" icon={History2Icon}>
        {t`Past medication requests`}
      </Heading>

      {isLoading && <TableSkeleton columns={6} rows={3} />}

      {isSuccess && (
        <>
          <PastMedicationRequestsTable
            pastMedicationRequests={pastMedicationRequests}
          />

          <PastMedicationRequestsCards
            pastMedicationRequests={pastMedicationRequests}
          />
        </>
      )}

      {isError && <ErrorState />}
    </section>
  );
};
